import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { BookOpen, ExternalLink, Globe, CheckCircle } from 'lucide-react';

export default function VJJournal() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="vj-journal-page py-5">
      <Helmet>
        <title>Vidyajyoti Journal (VJTR) - Vidyajyoti College of Theology</title>
        <meta name="description" content="Vidyajyoti Journal of Theological Reflection (VJTR) is a monthly peer-reviewed theological research journal published since 1938." />
      </Helmet>

      <div className="container">
        {/* Header */}
        <div className="text-center mx-auto pb-5" style={{ maxWidth: '800px' }}>
          <span className="text-burgundy fw-bold text-uppercase small" style={{ letterSpacing: '0.1em' }}>
            PEER-REVIEWED THEOLOGICAL JOURNAL
          </span>
          <h1 className="vj-card-title display-6 fw-bold mt-1 text-dark-main">
            Vidyajyoti Journal of Theological Reflection (VJTR)
          </h1>
          <p className="text-muted mt-2">
            Fostering contextual theological reflection on social, cultural, and spiritual realities in South Asia and globally since 1938.
          </p>
          <div className="mx-auto mt-2" style={{ width: '60px', height: '3px', background: '#79031d', borderRadius: '2px' }} />
        </div>

        {/* Feature Overview Card */}
        <div className="vj-modern-card p-4 p-md-5 mb-5" style={{ borderLeft: '5px solid #1a2b56' }}>
          <div className="row g-4 align-items-center">
            <div className="col-lg-8">
              <div className="d-flex align-items-center gap-2 mb-3">
                <div className="vj-icon-badge">
                  <BookOpen size={22} />
                </div>
                <h3 className="fw-bold fs-4 text-dark mb-0">About the Journal</h3>
              </div>
              <p className="text-muted" style={{ lineHeight: '1.8' }}>
                <strong>VJTR</strong> is published 12 times a year by the Vidyajyoti Educational and Welfare Society (VIEWS). Begun under the title <em>The Clergy Monthly</em> in 1938, the journal assumed its present title in 1975.
              </p>
              <p className="text-muted" style={{ lineHeight: '1.8' }}>
                This monthly publication reaches nearly <strong>4,000 subscribers worldwide</strong>, including premier theological faculties and university libraries in English-speaking nations.
              </p>
              <div className="pt-2">
                <a
                  href="https://vidyajyotijournal.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="vj-btn-primary"
                >
                  Visit Official VJTR Portal <ExternalLink size={16} />
                </a>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="p-4 rounded-4 bg-light border text-center">
                <Globe size={36} className="text-primary mb-2" />
                <h5 className="fw-bold text-dark mb-1">Global Circulation</h5>
                <p className="text-muted small mb-3">Over 85 years of continuous scholarly publication.</p>
                <div className="d-flex flex-column gap-2 text-start small text-muted">
                  <span className="d-flex align-items-center gap-2">
                    <CheckCircle size={15} className="text-burgundy flex-shrink-0" />
                    <span>12 Issues Published Annually</span>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <CheckCircle size={15} className="text-burgundy flex-shrink-0" />
                    <span>Double-Blind Peer Reviewed</span>
                  </span>
                  <span className="d-flex align-items-center gap-2">
                    <CheckCircle size={15} className="text-burgundy flex-shrink-0" />
                    <span>Interreligious & Contextual Focus</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scope & Editorial Vision */}
        <div className="row g-4 mb-5">
          <div className="col-md-6 d-flex">
            <div className="vj-modern-card p-4 w-100">
              <h4 className="fw-bold fs-5 text-dark mb-3">Scope & Focus Areas</h4>
              <p className="text-muted small mb-0" style={{ lineHeight: '1.8' }}>
                VJTR covers areas of Christian theology, ministry, interreligious dialogue, subaltern hermeneutics, and socio-economic ethics significant for the Church and modern society. It mediates the contributions of leading South Asian and international scholars to clergy, religious leaders, and lay thinkers.
              </p>
            </div>
          </div>

          <div className="col-md-6 d-flex">
            <div className="vj-modern-card p-4 w-100">
              <h4 className="fw-bold fs-5 text-dark mb-3">Academic Freedom & Dialogue</h4>
              <p className="text-muted small mb-0" style={{ lineHeight: '1.8' }}>
                The Journal respects creative freedom of theological and pastoral research within the parameters of the Gospel. Published from the Catholic perspective, it remains actively open to diverse philosophical and inter-faith viewpoints in the pursuit of truth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
